import React from 'react';

const ToggleInput = ({handleToggle})=>{

     const [show,setShow] = React.useState(true);

     const cls = show ?'btn-outline-danger' :'btn-outline-danger';

     return (
        <>
            <span 
                className ={`btn  ${cls} btn-sm rounded mr-2`}
                style = {{position:'absolute',right:'14px',top:'-3px'}}
                onClick = {()=>{
                    setShow(!show);
                    handleToggle();
                }}

            > 
        
                { 
                    show 
                    ? <i className ='fa fa-times'></i>
                    : <i className ='fa fa-list'></i>
                }

            </span>
        </>
     );

};

export default ToggleInput;